export type ElementUnfocusedValueLengthBucket =
    | 'empty'
    | '1_10'
    | '11_50'
    | '51_100'
    | '101_250'
    | '251_plus';

export type LastTrackedElementUnfocusedValue = {
    field: string;
    value: string;
} | null;

export const getElementUnfocusedValueMetadata = (value: string) => {
    const length = value.length;
    let valueLengthBucket: ElementUnfocusedValueLengthBucket = '251_plus';

    if (length === 0) {
        valueLengthBucket = 'empty';
    } else if (length <= 10) {
        valueLengthBucket = '1_10';
    } else if (length <= 50) {
        valueLengthBucket = '11_50';
    } else if (length <= 100) {
        valueLengthBucket = '51_100';
    } else if (length <= 250) {
        valueLengthBucket = '101_250';
    }

    return {
        hasValue: length > 0,
        valueLengthBucket,
    };
};

export const shouldTrackElementUnfocusedValue = ({
    field,
    value,
    lastTracked,
}: {
    field: string | null | undefined;
    value: string | null | undefined;
    lastTracked: LastTrackedElementUnfocusedValue;
}) => {
    if (!field || value == null) {
        return false;
    }
    return !(lastTracked?.field === field && lastTracked.value === value);
};
